export interface ReleaseNote {
  id: string;
  date: string;
  title: string;
  summary: string;
  content: string;
  heroImage: string;
  images?: string[];
  ctaLabel?: string;
  ctaUrl?: string;
  tags?: string[];
  isNewUntil: string;
}

export const releaseNotes: ReleaseNote[] = [
  {
    id: 'rn-002',
    date: '16 de Abril, 2026',
    title: 'Integração com ClickUp e Novo Chat',
    summary: 'Gerencie suas tarefas mais rápido conectando seu Workspace ao longo do chat.',
    content: `
A nova integração com o ClickUp transforma a maneira como você gerencia tarefas. Agora você pode:
- **Criar tarefas** diretamente do chat.
- **Atualizar status** sem sair da conversa.
- **Acompanhar progresso** dos projetos.

Além disso, a interface de chat foi totalmente redesenhada para suportar múltiplos agentes, com melhor acessibilidade e contraste. Nossa nova engine garante que respostas cheguem com menos de 200ms de latência.
    `.trim(),
    heroImage: '/placeholder.jpg',
    images: ['/placeholder.jpg'],
    ctaLabel: 'Ver Documentação',
    ctaUrl: 'https://example.com/docs',
    tags: ['Integração', 'Produtividade'],
    isNewUntil: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString(), // 7 days from now
  },
  {
    id: 'rn-001',
    date: '02 de Março, 2026',
    title: 'Agentes de IA Personalizados',
    summary: 'Crie agentes específicos para cada necessidade da sua empresa, treinados com seus dados.',
    content: `
Apresentamos nossos Agentes de IA Personalizados! Esta funcionalidade permite que você treine agentes utilizando a base de conhecimento específica da sua empresa.

Estes agentes podem:
- **Sugerir respostas** baseadas no histórico de atendimento.
- **Validar documentos** automaticamente.
- **Classificar tickets** com precisão melhorada de 85%.

Explore a nova aba de configuração de Agentes no seu painel principal para começar.
    `.trim(),
    heroImage: '/placeholder.jpg',
    tags: ['IA', 'Beta'],
    isNewUntil: new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString(), // Past date, not new
  }
];
